module.exports = __webpack_public_path__ + "img/Error.1ac877c8.svg";